import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { faqData } from '@/constants/faqData';

interface FAQContentProps {
  onClose?: () => void;
}

export const FAQContent: React.FC<FAQContentProps> = ({ onClose }) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4 pb-8">
      <Accordion type="single" collapsible className="space-y-3">
        {faqData.map((faq) => (
          <AccordionItem
            key={faq.id}
            value={faq.id}
            className="border border-border/20 rounded-lg px-4 py-1 bg-muted/20"
          >
            <AccordionTrigger className="text-left text-base font-medium hover:no-underline">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground leading-relaxed pt-1">
              <div 
                dangerouslySetInnerHTML={{ __html: faq.answer }}
                onClick={(e) => {
                  const target = e.target as HTMLElement;
                  if (target.tagName === 'A' && target.getAttribute('href')?.startsWith('/')) {
                    e.preventDefault();
                    const href = target.getAttribute('href');
                    if (href && onClose) {
                      onClose();
                      navigate(href);
                    }
                  }
                }}
              />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};